export default {
  defaultButtonText: 'Upload',
};
